<template>
  <div>
    <div :id="id"  style="width:100%;height:225px;position:relative"></div>
  </div>
</template>
<script>
export default {
  props: {
    echarts10Data: {
      type: Object,
      default: () => {
        return {
        };
      }
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      echarts08Datas:this.echarts10Data
    };
  },
  watch:{
    echarts10Data:{
      handler(newval, oldval) {
        this.echarts08Datas = newval
        this.pies();
      }
    }
  },
  mounted() {
    this.pies();
  },
  destroyed() {},
  methods: {
    pies() {
      var _this = this;
      console.log(_this.echarts08Datas.ExcutedCount)
      var becharts08 = this.$echarts.init(document.getElementById(_this.id));
      var placeHolderStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          color: "rgba(0,0,0,0)",
          borderWidth: 0
        },
        emphasis: {
          color: "#243255",
          borderWidth: 0
        }
      };

      var dataStyle = {
        normal: {
          formatter: "{c}%",
          position: "center",
          show: true,
          textStyle: {
            fontSize: "24",
            fontWeight: "normal",
            color: "#fff"
          }
        }
      };
      let sum =
        _this.echarts08Datas.UnExcuteCount + _this.echarts08Datas.ExcutedCount;
      var option = {
        series: [
          {
            name: "统计",
            type: "gauge",
            clockWise: true, //顺时加载
            startAngle: 230,
            endAngle: -50,
            radius: "80%", //图表尺寸
            center: ["45%", "42%"],
            axisLine: {
              show: true,
              lineStyle: {
                width: 5,
                shadowBlur: 0,
                color: [[1, "#fff"]]
              }
            },
            axisTick: {
              show: false,
              lineStyle: {
                color: "auto",
                width: 2
              },
              length: -20,
              splitNumber: 5
            },
            splitLine: {
              show: false,
              length: -30,
              lineStyle: {
                color: "auto",
                width: 2
              }
            },
            axisLabel: {
              show: false
            },
            pointer: {
              //仪表盘指针
              show: false
            },
            detail: {
              show: true,
              offsetCenter: [0, "-30%"], // x, y，单位px
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "#01D2D2",
                fontSize: 12
              },
              formatter: "已执行"
            },
            data: []
          },
          {
            type: "gauge",
            radius: "90%",
            center: ["45%", "42%"],
            splitNumber: 0, //刻度数量
            startAngle: 230,
            endAngle: -50,
            axisLine: {
              show: true,
              lineStyle: {
                width: 14,
                color: [
                  [
                    _this.echarts08Datas.ExcutedCount / sum,
                    new _this.$echarts.graphic.LinearGradient(1, 1, 1, 0, [
                      {
                        offset: 0,
                        color: "#d1f1f4"
                      },
                      {
                        offset: 1,
                        color: "#1d92c9"
                      }
                    ])
                  ],
                  [
                    1,
                    new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: "#EBF1F4"
                      },
                      {
                        offset: 1,
                        color: "#EBF1F4"
                      }
                    ])
                  ]
                ]
              }
            },
            //分隔线样式。
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: true
            },
            pointer: {
              show: false
            },
            title: {
              show: true,
              offsetCenter: [0, "-30%"], // x, y，单位px
              textStyle: {
                color: "#00CBCB",
                fontSize: 10
              }
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              offsetCenter: [0, "16%"],
              color: "#9F8646",
              clockWise: true,
              formatter: function(params) {
                // console.log(params);
                return params;
              },
              textStyle: {
                fontSize: 22
              }
            },
            data: [
              {
                value: _this.echarts08Datas.ExcutedCount,
                itemStyle: {
                  normal: {
                    color: new _this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: "#F5340C"
                        },
                        {
                          offset: 1,
                          color: "#0E152E"
                        }
                      ]
                    )
                  }
                },
                label: dataStyle
              },
              {
                value: _this.echarts08Datas.ExcutedCount,
                itemStyle: placeHolderStyle
              }
            ]
          }
        ]
      };

      becharts08.setOption(option,true);
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts4.vue